import React from "react";
import { templateForms } from "../templateForms";
import { InfoTooltip } from "./InfoTooltip";

export function RequiredFormsHub() {
  return (
    <section className="section-card">
      <h2 className="text-lg font-semibold text-slate-900">Required Forms — Download &amp; Overview</h2>
      <p className="mt-1 text-sm text-slate-600">
        These forms are provided here for your convenience. You can also download each one later in
        the relevant step.
      </p>
      <div className="mt-4 space-y-3">
        {templateForms.map((form) => (
          <div
            key={form.id}
            className="flex flex-wrap items-start justify-between gap-3 rounded-md border border-slate-200 p-4"
          >
            <div className="min-w-0">
              <p className="font-medium text-slate-900">
                {form.title} <InfoTooltip content={form.instructions} />
              </p>
              <p className="mt-1 text-xs text-slate-500">Completed by: {form.completedBy}</p>
              <div className="mt-2 flex flex-wrap items-center gap-2">
                <span className="inline-block rounded-md bg-program/10 px-2 py-1 text-xs text-program">
                  Used in: {form.usedInLabel}
                </span>
                {form.conditional && form.conditionalNote && (
                  <span className="text-xs text-amber-700">{form.conditionalNote}</span>
                )}
              </div>
            </div>
            <a
              href={`/templates/${form.id}.pdf`}
              download
              className="btn-secondary text-xs whitespace-nowrap"
            >
              Download
            </a>
          </div>
        ))}
      </div>
    </section>
  );
}
